import { Reveal, Overline } from "./motion";
import { GALLERY } from "../data/content";

export const PhotoGallery = () => (
  <section data-testid="photo-gallery" className="py-24 overflow-hidden border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Overline>Life at the College</Overline>
        <h2 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight text-navy leading-tight max-w-2xl">
          Workshops, trails, and snow — this is the classroom.
        </h2>
      </Reveal>
    </div>
    <div className="mt-14">
      <div className="animate-marquee-slow flex w-max gap-6 px-3 hover:[animation-play-state:paused]">
        {[...GALLERY, ...GALLERY].map((g, i) => (
          <figure
            key={i}
            data-testid={i < GALLERY.length ? `gallery-item-${i}` : undefined}
            className="group relative w-[300px] md:w-[380px] shrink-0 overflow-hidden rounded-sm"
          >
            <img
              src={g.src}
              alt={g.caption}
              className="h-64 md:h-80 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
            />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-navy/70 to-transparent px-5 pb-4 pt-10">
              <p className="font-serif italic text-lg text-primary-foreground">{g.caption}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
